import { CurrencyCode } from '../types/CurrencyCode';
import { MonetaryAmount } from '../types/MonetaryAmount';

import i18n from './i18n';

const DEFAULT_MINIMUM_FRACTION_DIGITS = 2;

export const formatAmount = (
  params: { amount: MonetaryAmount; currency?: CurrencyCode },
  options: Intl.NumberFormatOptions = {},
) => {
  const { amount, currency } = params;
  const {
    minimumFractionDigits = DEFAULT_MINIMUM_FRACTION_DIGITS,
    useGrouping,
    ...restOptions
  } = options;

  const language = i18n.language;

  return new Intl.NumberFormat(language, {
    ...restOptions,
    currency,
    currencyDisplay: 'code',
    minimumFractionDigits,

    // Не выводить валюту, если она не указана.
    style: currency ? 'currency' : 'decimal',

    // Не использовать группировку разрадов для чисел, состоящих из 4-х цифр и менее.
    useGrouping: useGrouping ?? Number(amount) / 10000 >= 1,
  }).format(Number(amount));
};
